import { c as _c } from "react/compiler-runtime";
import type { MapData } from '@repo/types/maps/map-types';
import { useMemo } from 'react';
export function use3dObjectsLookupMap(mapData) {
  const $ = _c(2);
  mapData?.objects3d?.features;
  let t0;
  if ($[0] !== mapData?.objects3d?.features) {
    const objects3d = mapData?.objects3d?.features || [];
    t0 = new Map(objects3d.map(_temp));
    $[0] = mapData?.objects3d?.features;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function _temp(object) {
  return [object.properties.externalId, object] as const;
}